import { useMediaQuery } from "@mantine/hooks";
import { Modal, Button } from "@mantine/core";
import { useState } from "react";
function ExtraExpenseDiscount({
  expenseName,
  setExpenseName,
  expenseValue,
  setExpenseValue,
  addExpense,
  discountValue,
  setDiscountValue,
  addDiscount,
  currencySymbol,
}: any) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [opened, setOpened] = useState(false);

  const content = (
    <div className="">
      <div className="mb-4">
        <h3 className="text-m font-medium mb-2">Add Extra Expense</h3>
        <input
          type="text"
          value={expenseName}
          onChange={(e) => setExpenseName(e.target.value)}
          placeholder="Type expense name"
          className="border p-2 w-full mb-2 rounded !bg-white"
        />
        <div className="flex space-x-2 mb-2">
          <div className="relative">
            <span className="absolute inset-y-0 left-0 flex items-center ml-2 text-gray-500">
              {currencySymbol()}
            </span>
            <input
              type="text"
              value={expenseValue}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  setExpenseValue(e.target.value);
                }
              }}
              placeholder="Add amount"
              className="border p-2 w-full pl-5 rounded !bg-white"
              min="0"
            />
          </div>
          <button
            onClick={addExpense}
            className="px-4 py-2 bg-orange-500 text-white h-full text-sm "
          >
            Add
          </button>
        </div>
      </div>

      <div>
        <h3 className="text-m font-medium mb-2">Add Discount</h3>
        <div className="flex space-x-2 mb-2">
          <div className="relative">
            <span className="absolute inset-y-0 left-0 flex items-center ml-2 text-gray-500">
              {currencySymbol()}
            </span>
            <input
              type="text"
              value={discountValue}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d*$/.test(value)) {
                  setDiscountValue(e.target.value);
                }
              }}
              placeholder="Add amount"
              className="border p-2 w-full  pl-5 rounded !bg-white"
              min="0"
            />
          </div>
          <button
            onClick={addDiscount}
            className="px-4 py-2 bg-orange-500 text-white h-full text-sm"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {isMobile ? (
        <>
          <div className="flex items-center gap-2 mb-4">
            <Button
              variant="outline"
              color="orange"
              fullWidth
              onClick={() => setOpened(true)}
            >
              Add extra expense/discount
            </Button>
          </div>

          {opened && (
            <Modal
              opened={opened}
              onClose={() => setOpened(false)}
              title="More Options"
              centered
              size="small"
              overlayProps={{
                backgroundOpacity: 0.55,
                blur: 3,
              }}
            >
              {content}
            </Modal>
          )}
        </>
      ) : (
        <div className="w-1/3 ml-6">{content}</div>
      )}
    </>
  );
}

export default ExtraExpenseDiscount;
